import StatementRejectionDialog from './StatementRejectionDialog';

export default StatementRejectionDialog;
